(function () {
  var desktopQuery = window.matchMedia('(min-width: 1068px)');
  var layoutTimer = null;

  function getPanelItems(panel) {
    var list = panel ? panel.querySelector('.header-sidebar-flyout__list') : null;
    if (!list) return [];
    return Array.prototype.filter.call(list.children, function (child) {
      return child.classList && child.classList.contains('header-sidebar-flyout__item');
    });
  }

  function syncPanelColumns(flyout) {
    if (!flyout) return;

    flyout.querySelectorAll('[data-flyout-col="2"], [data-flyout-col="3"]').forEach(function (panel) {
      var items = getPanelItems(panel);
      var hasChildren = items.some(function (item) {
        return item.classList.contains('header-sidebar-flyout__item--has-children');
      });
      var hasCards = items.some(function (item) {
        return item.classList.contains('header-sidebar-flyout__item--l3');
      });
      var split = items.length > 4 && !hasChildren;

      panel.classList.toggle('header-sidebar-flyout__panel--split-final', split);
      panel.classList.toggle('header-sidebar-flyout__panel--split-final-lines', split && !hasCards);
      panel.classList.toggle('header-sidebar-flyout__panel--split-final-cards', split && hasCards);
    });
  }

  function syncOpenFlyoutColumns() {
    if (!desktopQuery.matches) return;

    var root = document.querySelector('[data-sidebar-flyout-root]');
    var stack = document.querySelector('[data-sidebar-flyout-stack]');
    if (!root || !stack || root.hasAttribute('hidden')) return;

    var flyout = stack.querySelector('[data-sidebar-flyout]:not([hidden])');
    if (!flyout) return;

    syncPanelColumns(flyout);
  }

  function scheduleLayout(delay) {
    if (layoutTimer) window.clearTimeout(layoutTimer);
    layoutTimer = window.setTimeout(function () {
      layoutTimer = null;
      window.requestAnimationFrame(syncOpenFlyoutColumns);
    }, delay || 0);
  }

  function bind() {
    var root = document.querySelector('[data-sidebar-flyout-root]');
    if (!root || root.getAttribute('data-layout-bound') === 'true') return;

    root.setAttribute('data-layout-bound', 'true');

    var observer = new MutationObserver(function () {
      scheduleLayout(0);
      scheduleLayout(90);
    });
    observer.observe(root, {
      attributes: true,
      subtree: true,
      attributeFilter: ['hidden', 'class', 'style']
    });

    root.addEventListener('mouseenter', function () {
      scheduleLayout(0);
    }, true);
    window.addEventListener('resize', function () {
      scheduleLayout(40);
    });

    scheduleLayout(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
